import React from 'react';

import {StandingsWidgetTableRow} from "./standings-widget.table-row";
import {StandingsWidgetRowViewModel} from "../../models/standings-widget.row-view-model";
import {StandingsWidgetController} from "../../standings-widget.controller";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {ScrollableTable} from "../../../../core/components/scrollable-table/scrollable-component";

export class StandingsWidgetTableContentProps extends BaseProps {
  rows: Array<StandingsWidgetRowViewModel>;
  controller: StandingsWidgetController;
  groupTitle: String;
  source: String;
  shouldRenderTable: Boolean;
}

export const StandingsWidgetTableContent = ({
                                              controller,
                                              isGroup,
                                              rows,
                                              source,
                                              shouldRenderTable,
                                              num,
                                              groupTitle,
                                              headers,
                                            }: StandingsWidgetTableContentProps) => {
  const {state, device} = controller;

  const headerComponentProps = {
    controller, groupTitle, headers
  }

  const rowComponentProps = {
    source, controller,
  }

  const scrollableTableProps = {
    isGroup,
    num,
    shouldRenderTable,
    headerComponentProps,
    RowComponent: StandingsWidgetTableRow,
    rowComponentProps,
    rows,
    hasNotMajorHeaders: state.hasNotMajorHeaders,
    isSmallView: device.isSmallView,
    disableScrolling: state.onlyMajorColumns,
    leftOffset: 64,
  }

  return <ScrollableTable {...scrollableTableProps}/>

};
